import 'react';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/functions';
import Login from '../Components/Login/Login'

export const login = async (creds) => {
    try {
        const authSnapshot = await firebase.auth().signInWithEmailAndPassword(creds.email, creds.password);
        const userData = await getUserData(authSnapshot.user.uid);
        return userData.accessLevel;
    }
    catch(error) {
        // eslint-disable-next-line
        throw "Invalid credentials";
    }
}

export const getUserData = async (uid) => {
    try {
        console.log(uid)
        const snap = await firebase.firestore().doc(`users/${uid}`).get();
        const userData = snap.data();
        userData.uid = uid;
        return userData;
    }
    catch(error) {
        console.log(error);
    }
}

export const getAllUsers = async () => {
    try {
        let users = [];
        const usersSnapshot = await firebase.firestore().collection('users').get();
        let userData;
        usersSnapshot.forEach(doc => {
            userData = doc.data();
            userData.uid = doc.id;
            users.push(userData);
        });
        return users;
    }
    catch(error) {
        console.log(error);
    }
}

export const addUser = async (userData) => {
    try {
        const userCreateSnapshot = await firebase.auth().createUserWithEmailAndPassword(userData.email, userData.password);
        await userCreateSnapshot.user.updateProfile({ displayName: userData.displayName });
        delete userData.password;
        await firebase.firestore().doc(`users/${userCreateSnapshot.user.uid}`).set(userData)
        console.log("done")
    }
    catch(error) {
        console.log(error);
        // eslint-disable-next-line
        throw 'Couldn\'t create user. please check entered data. Probably the email already exists';
    }
}

export const deleteUser = (uid) => {
    const deleteUserCloudFunction = firebase.functions().httpsCallable('deleteUser');
    deleteUserCloudFunction({ uid })
        .then(() => console.log('user deleted'))
        .catch(error => console.log(error));
}

export const authGuard = (Component) => {
    if (firebase.auth().currentUser) {
        console.log(true)
        return Component;
    }
    return Login
}

export const getUserType = async (uid) => {
    try {
        const userData = await getUserData(uid)
        return userData.accessLevel
    }
    catch(error) {
        // eslint-disable-next-line
        throw error
    }
}